import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dc9c61de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog profile-dialog" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "修改昵称")
], -1))
const _hoisted_3 = { class: "field" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "btn red" }, "保 存", -1))
const _hoisted_5 = [
  _hoisted_4
]

import devices from '@/store/device';
import user, { State } from '@/store/user';
import { computed, onMounted, reactive } from 'vue';
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  emits: ["close"],
  setup(__props, { emit: emits }: { emit: ({
    (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const store = useStore();
const data = computed<State>(() => store.state[user.name])
const state = reactive({
    nickname: ''
})

onMounted(() => {
    if (data.value.info) {
        state.nickname = data.value.info.nickname
    }
})

async function onSubmit() {
    if (!state.nickname) {
        return devices.toast(store, '请输入昵称')
    }
    try {
        await user.updateNickname(store, state.nickname)
        devices.toast(store, '修改成功')
        emits('close')
    } catch (e) {
        devices.toast(store, '修改失败')
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: "close icon i-guanbi c-thirdary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('close')))
    }),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).nickname) = $event)),
        placeholder: "请输入昵称"
      }, null, 512), [
        [_vModelText, _unref(state).nickname]
      ])
    ]),
    _createElementVNode("div", {
      class: "submit",
      onClick: onSubmit
    }, _hoisted_5)
  ]))
}
}

})